export enum ProgressOneStatus {
  Success = 'success',
  Exception = 'exception',
  Active = 'active',
  Normal = 'normal'
}
